<template>
  <div class="animate-route">
    <details-info :title="productInfo.name" describe :htmlStr="productInfo.content">
      <!-- <template slot="describe">
        <div class="describe">{{ productInfo.content }}</div>
      </template> -->
    </details-info>
  </div>
</template>
<script>
import DetailsInfo from '@/components/DetailsInfo'
import { getProductById } from '@/api'
export default {
  components: {
    DetailsInfo,
  },
  data() {
    return {
      productInfo: {},
      imgUrl: process.env.VUE_APP_IMG_URL,
    }
  },
  created() {
    const id = this.$route.query.id
    getProductById({ id: id }).then((res) => {
      this.productInfo = res.result
    })
  },
}
</script>
<style lang="stylus">
@import './index'
route()
</style>
